import { Injectable } from '@angular/core';
import { HeaderService } from '../core/header/header.service';

@Injectable({
  providedIn: 'root'
})
export class ActionsCommonService {
  public JSONMaxSize = 20;
  private _selectedModule: any;
  private headerData = {
    title: '',
    breadCrumb: [],
    desc: ''
  };

  constructor(private headerService: HeaderService) { }

  setModule(selectedModule) {
    this._selectedModule = selectedModule;
  }

  getModule() {
    return this._selectedModule;
  }

  setHeaderData(data) {
    this.headerData = data;
    this.headerService.setHeaderData(this.headerData);
  }

  /**
   * Tag text getter
   *
   * @param   string  val
   *
   * @return  string
   */
  getTagText(val) {
    switch (val) {
      case 'Number': {
        return 'Num';
      }
      case 'Boolean': {
        return 'Bool';
      }
      case 'String': {
        return 'Str';
      }
      case 'JSON': {
        return 'JSON';
      }
    }
  }

  memorySizeOf(text: any) {
    const isWin = navigator.platform.indexOf('Win') === 0;
    const crlf = /(\r?\n|\r)/g;
    const whitespace = /(\r?\n|\r|\s+)/g;
    const ByteSize = {
      count: function (text, options?) {
        // Set option defaults
        options = options || {};
        options.lineBreaks = options.lineBreaks || 1;
        options.ignoreWhitespace = options.ignoreWhitespace || false;

        const length = text.length,
          nonAscii = length - text.replace(/[\u0100-\uFFFF]/g, '').length,
          lineBreaks = length - text.replace(crlf, '').length;

        if (options.ignoreWhitespace) {
          // Strip whitespace
          text = text.replace(whitespace, '');

          return text.length + nonAscii;
        } else {
          return length + nonAscii + Math.max(0, options.lineBreaks * (lineBreaks - 1));
        }
      },

      format: function (count, plainText?) {
        /* let level: any = 0;

        while (count > 1024) {
          count /= 1024;
          level++;
        }

        // Round to 2 decimals
        count = Math.round(count * 100) / 100;

        level = ['', 'K', 'M', 'G', 'T'][level];

        return count + ' ' + level + 'B'; */

        return count /= 1024; // always return in KB
      }
    };

    const sizeUnix = ByteSize.format(ByteSize.count(text)),
      sizeWin = ByteSize.format(ByteSize.count(text, {
        lineBreaks: 2
      }));
    return isWin ? sizeWin : sizeUnix;
  }
}
